export * from './useCreateModelingDetectObjects';
export { default as useCreateModelingDetectObjects } from './useCreateModelingDetectObjects';
